<div class="wrapper-md" *ngIf="report">
    <app-breadcrumbs [items]="[
                     { url: '/thesis-reports', text: 'thesisReport_listTitle' },
                     {
                        url: '/thesis-reports/' + report.Id,
                        text: 'thesisReport_viewTitle'
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{'thesisReport_viewTitle' | translate}}
        </h1>
    </header>

    <div class="data-value col-sm">
        <label>{{'thesisReport_lblDoctor' | translate}}</label>
        <div>{{report.FirstName}} {{report.LastName}}, {{report.CertificateNumber}}</div>
    </div>

    <div class="data-value" *ngIf="report.PureProfileUrl">
        <label>{{'thesisReport_lblPureProfile' | translate}}</label>
        <div>
            <a href="{{report.PureProfileUrl}}" target="_blank">{{'thesisReport_lblPureProfileLink' | translate}}</a>
        </div>
    </div>

    <div class="data-value">
        <label>{{'thesisReport_lblStudyProgram' | translate}}</label>
        <div>[{{report.StudyProgramCode}}] {{report.StudyProgramName}}</div>
    </div>

    <div class="data-value">
        <label>{{'thesisReport_lblSupervisor' | translate}}</label>
        <div>{{getSupervisorDisplay(report)}}</div>
    </div>

    <div class="data-value">
        <label>{{'thesisReport_lblProgress' | translate}}</label>
        <div>{{report.Progress}}</div>
    </div>

    <div class="data-value">
        <label>{{'thesisReport_lblHasScientificActivity' | translate}}</label>
        <div>{{(report.HasScientificActivity ? 'valueYes' : 'valueNo') | translate}}</div>
    </div>

    <div class="data-value">
        <label>{{'thesisReport_lblHasTeachingActivity' | translate}}</label>
        <div>{{(report.HasTeachingActivity ? 'valueYes' : 'valueNo') | translate}}</div>
    </div>

    <div class="data-value">
        <label>{{'thesisReport_lblCooperationGrade' | translate}}</label>
        <div>{{report.CooperationGrade}}</div>
    </div>

    <div class="data-value">
        <label>{{'thesisReport_lblAttachments' | translate}}</label>
        <div *ngFor="let a of report.Attachments; let i = index">
            <a href="#" (click)="$event.preventDefault(); downloadAttachment(a.Id, a.FileName)"><i class="fi fi-rs-download"></i> {{a.FileName}}</a>
        </div>
    </div>

    <div class="form-actions">
        <button class="btn btn-outline" type="button" [routerLink]="['/thesis-reports'] | localize">
            {{'thesisReport_btnClose' | translate}}
        </button>
    </div>
</div>
